export const propertyData = {
  en: {
    nav: {
      overview: 'Overview',
      highlights: 'Highlights',
      specifications: 'Specifications',
      gallery: 'Gallery',
      location: 'Location',
      contact: 'Contact'
    },
    hero: {
      title: 'Traditional Cottages in Skopelos',
      subtitle: 'Two Independent Houses • 8,000 m² Land • Unobstructed Sea Views',
      cta: 'Schedule Viewing'
    },
    overview: {
      title: 'Property Overview',
      description: 'Discover two charming traditional cottage houses set on a vast 8,000 square meter plot in Skopelos, Greece. These independent properties offer unobstructed panoramic sea views towards Skiathos and Alonissos islands, providing complete privacy in tranquil natural surroundings. Perfect as a luxury holiday retreat or a strategic investment opportunity in one of the Aegean\'s most sought-after destinations.',
      features: [
        {
          title: 'Two Independent Houses',
          description: 'Cottage 1 (32 m²) and Cottage 2 (23 m²) with 15 m² storage room - fully autonomous with distinct character'
        },
        {
          title: '8,000 m² Land Plot',
          description: 'Expansive private grounds offering complete privacy and development potential'
        },
        {
          title: 'Unobstructed Sea Views',
          description: 'Panoramic vistas of the Aegean Sea and neighboring islands of Skiathos and Alonissos'
        },
        {
          title: 'Natural Surroundings',
          description: 'Set in peaceful nature with authentic Mediterranean vegetation and serene atmosphere'
        }
      ]
    },
    specifications: {
      title: 'Property Specifications',
      details: [
        { label: 'Property Type', value: 'Two Traditional Cottages' },
        { label: 'Cottage 1', value: '32 m²' },
        { label: 'Cottage 2', value: '23 m²' },
        { label: 'Storage Room', value: '15 m²' },
        { label: 'Land Area', value: '8,000 m²' },
        { label: 'Location', value: 'Skopelos Island, Greece' },
        { label: 'View', value: 'Unobstructed Sea & Island Views' },
        { label: 'Privacy', value: 'Complete Privacy' },
        { label: 'Setting', value: 'Quiet Natural Surroundings' },
        { label: 'Ideal Use', value: 'Holiday Home / Investment' },
        { label: 'Islands Visible', value: 'Skiathos & Alonissos' }
      ]
    },
    gallery: {
      title: 'Photo Gallery'
    },
    location: {
      title: 'Location',
      description: 'Situated on the beautiful island of Skopelos in the Sporades archipelago, this property offers easy access to pristine beaches, traditional villages, and all essential amenities while maintaining complete privacy and tranquility.'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Interested in this unique property? Get in touch with us today.',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        message: 'Message',
        submit: 'Send Inquiry'
      },
      success: 'Thank you! Your inquiry has been submitted successfully.',
      error: 'Please fill in all required fields.'
    },
    footer: {
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    }
  },
  gr: {
    nav: {
      overview: 'Επισκόπηση',
      specifications: 'Προδιαγραφές',
      gallery: 'Φωτογραφίες',
      location: 'Τοποθεσία',
      contact: 'Επικοινωνία'
    },
    hero: {
      title: 'Παραδοσιακές Κατοικίες στη Σκόπελο',
      subtitle: 'Δύο Ανεξάρτητα Σπίτια • 8.000 τ.μ. Οικόπεδο • Απρόσκοπτη Θέα στη Θάλασσα',
      cta: 'Κλείστε Επίσκεψη'
    },
    overview: {
      title: 'Επισκόπηση Ακινήτου',
      description: 'Ανακαλύψτε δύο γοητευτικά παραδοσιακά εξοχικά σπίτια σε ένα τεράστιο οικόπεδο 8.000 τετραγωνικών μέτρων στη Σκόπελο. Αυτά τα ανεξάρτητα ακίνητα προσφέρουν απρόσκοπτη πανοραμική θέα στη θάλασσα προς τη Σκιάθο και την Αλόννησο, παρέχοντας απόλυτη ιδιωτικότητα σε ήσυχο φυσικό περιβάλλον. Ιδανικό ως πολυτελές καταφύγιο διακοπών ή στρατηγική επενδυτική ευκαιρία σε έναν από τους πιο περιζήτητους προορισμούς του Αιγαίου.',
      features: [
        {
          title: 'Δύο Ανεξάρτητα Σπίτια',
          description: 'Εξοχικό 1 (32 τ.μ.) και Εξοχικό 2 (23 τ.μ.) με αποθήκη 15 τ.μ. - πλήρως αυτόνομα με ξεχωριστό χαρακτήρα'
        },
        {
          title: 'Οικόπεδο 8.000 τ.μ.',
          description: 'Εκτεταμένος ιδιωτικός χώρος που προσφέρει απόλυτη ιδιωτικότητα'
        },
        {
          title: 'Απρόσκοπτη Θέα Θάλασσας',
          description: 'Πανοραμική θέα στο Αιγαίο και τα γειτονικά νησιά Σκιάθο και Αλόννησο'
        },
        {
          title: 'Φυσικό Περιβάλλον',
          description: 'Σε γαλήνιο περιβάλλον με αυθεντική μεσογειακή βλάστηση'
        }
      ]
    },
    specifications: {
      title: 'Προδιαγραφές Ακινήτου',
      details: [
        { label: 'Τύπος Ακινήτου', value: 'Δύο Παραδοσιακά Εξοχικά' },
        { label: 'Εξοχικό 1', value: '32 τ.μ.' },
        { label: 'Εξοχικό 2', value: '23 τ.μ.' },
        { label: 'Αποθήκη', value: '15 τ.μ.' },
        { label: 'Έκταση Οικοπέδου', value: '8.000 τ.μ.' },
        { label: 'Τοποθεσία', value: 'Νήσος Σκόπελος, Ελλάδα' },
        { label: 'Θέα', value: 'Απρόσκοπτη Θέα Θάλασσας & Νησιών' },
        { label: 'Ιδιωτικότητα', value: 'Απόλυτη Ιδιωτικότητα' },
        { label: 'Περιβάλλον', value: 'Ήσυχο Φυσικό Περιβάλλον' },
        { label: 'Ιδανική Χρήση', value: 'Εξοχική Κατοικία / Επένδυση' },
        { label: 'Ορατά Νησιά', value: 'Σκιάθος & Αλόννησος' }
      ]
    },
    gallery: {
      title: 'Φωτογραφίες'
    },
    location: {
      title: 'Τοποθεσία',
      description: 'Βρίσκεται στο όμορφο νησί της Σκοπέλου στο αρχιπέλαγος των Σποράδων, το ακίνητο προσφέρει εύκολη πρόσβαση σε παρθένες παραλίες, παραδοσιακά χωριά και όλες τις απαραίτητες ανέσεις διατηρώντας παράλληλα απόλυτη ιδιωτικότητα και ηρεμία.'
    },
    contact: {
      title: 'Επικοινωνία',
      subtitle: 'Ενδιαφέρεστε για αυτό το μοναδικό ακίνητο; Επικοινωνήστε μαζί μας σήμερα.',
      form: {
        name: 'Ονοματεπώνυμο',
        email: 'Email',
        phone: 'Τηλέφωνο',
        message: 'Μήνυμα',
        submit: 'Αποστολή'
      },
      success: 'Ευχαριστούμε! Η αίτησή σας υποβλήθηκε επιτυχώς.',
      error: 'Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία.'
    },
    footer: {
      rights: 'Όλα τα δικαιώματα διατηρούνται.',
      privacy: 'Πολιτική Απορρήτου',
      terms: 'Όροι Χρήσης'
    }
  },
  de: {
    nav: {
      overview: 'Übersicht',
      highlights: 'Highlights',
      specifications: 'Spezifikationen',
      gallery: 'Galerie',
      location: 'Lage',
      contact: 'Kontakt'
    },
    hero: {
      title: 'Traditionelle Cottages auf Skopelos',
      subtitle: 'Zwei unabhängige Häuser • 8.000 m² Grundstück • Freier Meerblick',
      cta: 'Besichtigung vereinbaren'
    },
    overview: {
      title: 'Immobilienübersicht',
      description: 'Entdecken Sie zwei charmante traditionelle Ferienhäuser auf einem weitläufigen 8.000 Quadratmeter großen Grundstück auf Skopelos, Griechenland. Diese unabhängigen Immobilien bieten einen unverbaubaren Panoramablick auf das Meer in Richtung Skiathos und Alonissos und gewährleisten vollständige Privatsphäre in ruhiger natürlicher Umgebung. Perfekt als luxuriöser Urlaubsort oder strategische Investitionsmöglichkeit.',
      features: [
        {
          title: 'Zwei unabhängige Häuser',
          description: 'Cottage 1 (32 m²) und Cottage 2 (23 m²) mit 15 m² Abstellraum - vollständig autonom mit eigenem Charakter'
        },
        {
          title: '8.000 m² Grundstück',
          description: 'Weitläufiges Privatgelände mit vollständiger Privatsphäre und Entwicklungspotenzial'
        },
        {
          title: 'Freier Meerblick',
          description: 'Panoramablick auf die Ägäis und die Nachbarinseln Skiathos und Alonissos'
        },
        {
          title: 'Natürliche Umgebung',
          description: 'In friedlicher Natur mit authentischer mediterraner Vegetation'
        }
      ]
    },
    specifications: {
      title: 'Immobilienspezifikationen',
      details: [
        { label: 'Immobilientyp', value: 'Zwei traditionelle Cottages' },
        { label: 'Cottage 1', value: '32 m²' },
        { label: 'Cottage 2', value: '23 m²' },
        { label: 'Abstellraum', value: '15 m²' },
        { label: 'Grundstücksfläche', value: '8.000 m²' },
        { label: 'Standort', value: 'Insel Skopelos, Griechenland' },
        { label: 'Aussicht', value: 'Freier Meer- und Inselblick' },
        { label: 'Privatsphäre', value: 'Vollständige Privatsphäre' },
        { label: 'Umgebung', value: 'Ruhige natürliche Umgebung' },
        { label: 'Ideale Nutzung', value: 'Ferienhaus / Investition' },
        { label: 'Sichtbare Inseln', value: 'Skiathos & Alonissos' }
      ]
    },
    gallery: {
      title: 'Fotogalerie'
    },
    location: {
      title: 'Lage',
      description: 'Auf der wunderschönen Insel Skopelos im Sporaden-Archipel gelegen, bietet dieses Anwesen einfachen Zugang zu unberührten Stränden, traditionellen Dörfern und allen wichtigen Annehmlichkeiten bei vollständiger Privatsphäre und Ruhe.'
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Interesse an dieser einzigartigen Immobilie? Kontaktieren Sie uns noch heute.',
      form: {
        name: 'Vollständiger Name',
        email: 'E-Mail-Adresse',
        phone: 'Telefonnummer',
        message: 'Nachricht',
        submit: 'Anfrage senden'
      },
      success: 'Vielen Dank! Ihre Anfrage wurde erfolgreich übermittelt.',
      error: 'Bitte füllen Sie alle erforderlichen Felder aus.'
    },
    footer: {
      rights: 'Alle Rechte vorbehalten.',
      privacy: 'Datenschutzrichtlinie',
      terms: 'Nutzungsbedingungen'
    }
  },
  he: {
    nav: {
      overview: 'סקירה',
      highlights: 'דגשים',
      specifications: 'מפרטים',
      gallery: 'גלריה',
      location: 'מיקום',
      contact: 'צור קשר'
    },
    hero: {
      title: 'קוטג\'ים מסורתיים בסקופלוס',
      subtitle: 'שני בתים עצמאיים • 8,000 מ"ר קרקע • נוף ים בלתי מוגבל',
      cta: 'קבע ביקור'
    },
    overview: {
      title: 'סקירת הנכס',
      description: 'גלו שני בתי קוטג\' מסורתיים מקסימים על חלקה עצומה של 8,000 מ"ר בסקופלוס, יוון. נכסים עצמאיים אלה מציעים נוף ים פנורמי בלתי מוגבל לכיוון סקיאתוס ואלוניסוס, ומספקים פרטיות מלאה בסביבה טבעית שקטה. מושלם כמפלט נופש יוקרתי או הזדמנות השקעה אסטרטגית.',
      features: [
        {
          title: 'שני בתים עצמאיים',
          description: 'קוטג\' 1 (32 מ"ר) וקוטג\' 2 (23 מ"ר) עם מחסן 15 מ"ר - אוטונומיים לחלוטין עם אופי ייחודי'
        },
        {
          title: '8,000 מ"ר קרקע',
          description: 'שטח פרטי נרחב המציע פרטיות מלאה ופוטנציאל פיתוח'
        },
        {
          title: 'נוף ים בלתי מוגבל',
          description: 'נוף פנורמי לים האגאי ולאיים השכנים סקיאתוס ואלוניסוס'
        },
        {
          title: 'סביבה טבעית',
          description: 'בטבע שליו עם צמחייה ים-תיכונית אותנטית'
        }
      ]
    },
    specifications: {
      title: 'מפרט הנכס',
      details: [
        { label: 'סוג נכס', value: 'שני קוטג\'ים מסורתיים' },
        { label: 'קוטג\' 1', value: '32 מ"ר' },
        { label: 'קוטג\' 2', value: '23 מ"ר' },
        { label: 'מחסן', value: '15 מ"ר' },
        { label: 'שטח קרקע', value: '8,000 מ"ר' },
        { label: 'מיקום', value: 'אי סקופלוס, יוון' },
        { label: 'נוף', value: 'נוף ים ואיים בלתי מוגבל' },
        { label: 'פרטיות', value: 'פרטיות מלאה' },
        { label: 'סביבה', value: 'סביבה טבעית שקטה' },
        { label: 'שימוש אידיאלי', value: 'בית נופש / השקעה' },
        { label: 'איים נראים', value: 'סקיאתוס ואלוניסוס' }
      ]
    },
    gallery: {
      title: 'גלריית תמונות'
    },
    location: {
      title: 'מיקום',
      description: 'ממוקם באי היפהפה סקופלוס בארכיפלג הספורדים, הנכס מציע גישה נוחה לחופים בתוליים, כפרים מסורתיים וכל המתקנים החיוניים תוך שמירה על פרטיות ושלווה מלאה.'
    },
    contact: {
      title: 'צור קשר',
      subtitle: 'מעוניינים בנכס ייחודי זה? צרו איתנו קשר היום.',
      form: {
        name: 'שם מלא',
        email: 'כתובת דוא"ל',
        phone: 'מספר טלפון',
        message: 'הודעה',
        submit: 'שלח פנייה'
      },
      success: 'תודה! פנייתך נשלחה בהצלחה.',
      error: 'אנא מלא את כל השדות הנדרשים.'
    },
    footer: {
      rights: 'כל הזכויות שמורות.',
      privacy: 'מדיניות פרטיות',
      terms: 'תנאי שימוש'
    }
  },
  fr: {
    nav: {
      overview: 'Aperçu',
      highlights: 'Points forts',
      specifications: 'Spécifications',
      gallery: 'Galerie',
      location: 'Emplacement',
      contact: 'Contact'
    },
    hero: {
      title: 'Cottages Traditionnels à Skopelos',
      subtitle: 'Deux maisons indépendantes • 8 000 m² de terrain • Vue mer dégagée',
      cta: 'Organiser une visite'
    },
    overview: {
      title: 'Aperçu de la propriété',
      description: 'Découvrez deux charmantes maisons de vacances traditionnelles sur un vaste terrain de 8 000 mètres carrés à Skopelos, en Grèce. Ces propriétés indépendantes offrent une vue panoramique imprenable sur la mer vers Skiathos et Alonissos, garantissant une intimité totale dans un cadre naturel paisible. Parfait comme retraite de vacances de luxe ou opportunité d\'investissement stratégique.',
      features: [
        {
          title: 'Deux maisons indépendantes',
          description: 'Cottage 1 (32 m²) et Cottage 2 (23 m²) avec 15 m² de rangement - entièrement autonomes au caractère unique'
        },
        {
          title: 'Terrain de 8 000 m²',
          description: 'Vaste domaine privé offrant intimité totale et potentiel de développement'
        },
        {
          title: 'Vue mer dégagée',
          description: 'Vue panoramique sur la mer Égée et les îles voisines de Skiathos et Alonissos'
        },
        {
          title: 'Cadre naturel',
          description: 'Dans une nature paisible avec une végétation méditerranéenne authentique'
        }
      ]
    },
    specifications: {
      title: 'Spécifications de la propriété',
      details: [
        { label: 'Type de propriété', value: 'Deux cottages traditionnels' },
        { label: 'Cottage 1', value: '32 m²' },
        { label: 'Cottage 2', value: '23 m²' },
        { label: 'Rangement', value: '15 m²' },
        { label: 'Surface du terrain', value: '8 000 m²' },
        { label: 'Emplacement', value: 'Île de Skopelos, Grèce' },
        { label: 'Vue', value: 'Vue mer et îles dégagée' },
        { label: 'Intimité', value: 'Intimité totale' },
        { label: 'Cadre', value: 'Environnement naturel calme' },
        { label: 'Usage idéal', value: 'Maison de vacances / Investissement' },
        { label: 'Îles visibles', value: 'Skiathos & Alonissos' }
      ]
    },
    gallery: {
      title: 'Galerie photos'
    },
    location: {
      title: 'Emplacement',
      description: 'Située sur la belle île de Skopelos dans l\'archipel des Sporades, cette propriété offre un accès facile aux plages préservées, aux villages traditionnels et à toutes les commodités essentielles tout en maintenant une intimité et une tranquillité totales.'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Intéressé par cette propriété unique ? Contactez-nous dès aujourd\'hui.',
      form: {
        name: 'Nom complet',
        email: 'Adresse e-mail',
        phone: 'Numéro de téléphone',
        message: 'Message',
        submit: 'Envoyer la demande'
      },
      success: 'Merci ! Votre demande a été soumise avec succès.',
      error: 'Veuillez remplir tous les champs obligatoires.'
    },
    footer: {
      rights: 'Tous droits réservés.',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation'
    }
  },
  zh: {
    nav: {
      overview: '概述',
      highlights: '亮点',
      specifications: '规格',
      gallery: '图库',
      location: '位置',
      contact: '联系'
    },
    hero: {
      title: '斯科派洛斯传统小屋',
      subtitle: '两栋独立房屋 • 8,000平方米土地 • 无遮挡海景',
      cta: '预约看房'
    },
    overview: {
      title: '房产概述',
      description: '在希腊斯科派洛斯岛上发现两栋迷人的传统小屋，占地8,000平方米。这些独立房产提供无遮挡的全景海景，可眺望斯基亚索斯和阿洛尼索斯岛，在宁静的自然环境中享有完全的隐私。非常适合作为豪华度假胜地或战略投资机会。',
      features: [
        {
          title: '两栋独立房屋',
          description: '小屋1（32平方米）和小屋2（23平方米），配有15平方米储藏室 - 完全自主，各具特色'
        },
        {
          title: '8,000平方米土地',
          description: '广阔的私人领地，提供完全的隐私和开发潜力'
        },
        {
          title: '无遮挡海景',
          description: '爱琴海和邻近岛屿斯基亚索斯和阿洛尼索斯的全景视野'
        },
        {
          title: '自然环境',
          description: '位于宁静的自然环境中，拥有地道的地中海植被'
        }
      ]
    },
    specifications: {
      title: '房产规格',
      details: [
        { label: '房产类型', value: '两栋传统小屋' },
        { label: '小屋1', value: '32平方米' },
        { label: '小屋2', value: '23平方米' },
        { label: '储藏室', value: '15平方米' },
        { label: '土地面积', value: '8,000平方米' },
        { label: '位置', value: '希腊斯科派洛斯岛' },
        { label: '景观', value: '无遮挡海景和岛景' },
        { label: '隐私', value: '完全隐私' },
        { label: '环境', value: '安静的自然环境' },
        { label: '理想用途', value: '度假屋/投资' },
        { label: '可见岛屿', value: '斯基亚索斯和阿洛尼索斯' }
      ]
    },
    gallery: {
      title: '图片库'
    },
    location: {
      title: '位置',
      description: '位于斯波拉泽斯群岛美丽的斯科派洛斯岛上，这处房产可轻松前往原始海滩、传统村庄和所有基本设施，同时保持完全的隐私和宁静。'
    },
    contact: {
      title: '联系我们',
      subtitle: '对这处独特房产感兴趣？今天就与我们联系。',
      form: {
        name: '全名',
        email: '电子邮箱',
        phone: '电话号码',
        message: '留言',
        submit: '发送询问'
      },
      success: '谢谢！您的询问已成功提交。',
      error: '请填写所有必填字段。'
    },
    footer: {
      rights: '版权所有。',
      privacy: '隐私政策',
      terms: '服务条款'
    }
  },
  ar: {
    nav: {
      overview: 'نظرة عامة',
      highlights: 'المميزات',
      specifications: 'المواصفات',
      gallery: 'معرض الصور',
      location: 'الموقع',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'أكواخ تقليدية في سكوبيلوس',
      subtitle: 'منزلان مستقلان • 8,000 م² أرض • إطلالات بحرية غير محجوبة',
      cta: 'حجز زيارة'
    },
    overview: {
      title: 'نظرة عامة على العقار',
      description: 'اكتشف منزلين ريفيين تقليديين ساحرين على قطعة أرض واسعة تبلغ 8,000 متر مربع في سكوبيلوس، اليونان. توفر هذه العقارات المستقلة إطلالات بانورامية غير محجوبة على البحر باتجاه سكياثوس وألونيسوس، مما يوفر خصوصية كاملة في محيط طبيعي هادئ. مثالي كملاذ عطلة فاخر أو فرصة استثمارية استراتيجية.',
      features: [
        {
          title: 'منزلان مستقلان',
          description: 'الكوخ 1 (32 م²) والكوخ 2 (23 م²) مع غرفة تخزين 15 م² - مستقلان تماماً بطابع فريد'
        },
        {
          title: '8,000 م² أرض',
          description: 'أرض خاصة واسعة توفر خصوصية كاملة وإمكانية تطوير'
        },
        {
          title: 'إطلالات بحرية غير محجوبة',
          description: 'إطلالات بانورامية على بحر إيجة والجزر المجاورة سكياثوس وألونيسوس'
        },
        {
          title: 'محيط طبيعي',
          description: 'في طبيعة هادئة مع نباتات متوسطية أصيلة'
        }
      ]
    },
    specifications: {
      title: 'مواصفات العقار',
      details: [
        { label: 'نوع العقار', value: 'كوخان تقليديان' },
        { label: 'الكوخ 1', value: '32 م²' },
        { label: 'الكوخ 2', value: '23 م²' },
        { label: 'غرفة التخزين', value: '15 م²' },
        { label: 'مساحة الأرض', value: '8,000 م²' },
        { label: 'الموقع', value: 'جزيرة سكوبيلوس، اليونان' },
        { label: 'الإطلالة', value: 'إطلالات بحرية وجزرية غير محجوبة' },
        { label: 'الخصوصية', value: 'خصوصية كاملة' },
        { label: 'المحيط', value: 'محيط طبيعي هادئ' },
        { label: 'الاستخدام المثالي', value: 'منزل عطلات / استثمار' },
        { label: 'الجزر المرئية', value: 'سكياثوس وألونيسوس' }
      ]
    },
    gallery: {
      title: 'معرض الصور'
    },
    location: {
      title: 'الموقع',
      description: 'يقع في جزيرة سكوبيلوس الجميلة في أرخبيل سبورادس، يوفر هذا العقار سهولة الوصول إلى الشواطئ البكر والقرى التقليدية وجميع المرافق الأساسية مع الحفاظ على الخصوصية والهدوء التام.'
    },
    contact: {
      title: 'اتصل بنا',
      subtitle: 'مهتم بهذا العقار الفريد؟ تواصل معنا اليوم.',
      form: {
        name: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        phone: 'رقم الهاتف',
        message: 'الرسالة',
        submit: 'إرسال الاستفسار'
      },
      success: 'شكراً لك! تم إرسال استفسارك بنجاح.',
      error: 'يرجى ملء جميع الحقول المطلوبة.'
    },
    footer: {
      rights: 'جميع الحقوق محفوظة.',
      privacy: 'سياسة الخصوصية',
      terms: 'شروط الخدمة'
    }
  },
  ru: {
    nav: {
      overview: 'Обзор',
      highlights: 'Особенности',
      specifications: 'Характеристики',
      gallery: 'Галерея',
      location: 'Расположение',
      contact: 'Контакты'
    },
    hero: {
      title: 'Традиционные коттеджи на Скопелосе',
      subtitle: 'Два независимых дома • 8 000 м² земли • Беспрепятственный вид на море',
      cta: 'Запланировать просмотр'
    },
    overview: {
      title: 'Обзор недвижимости',
      description: 'Откройте для себя два очаровательных традиционных коттеджа на обширном участке площадью 8 000 квадратных метров на Скопелосе, Греция. Эти независимые объекты предлагают беспрепятственный панорамный вид на море в сторону Скиатоса и Алониссоса, обеспечивая полную приватность в спокойной природной обстановке. Идеально подходит как роскошное место для отдыха или стратегическая инвестиционная возможность.',
      features: [
        {
          title: 'Два независимых дома',
          description: 'Коттедж 1 (32 м²) и Коттедж 2 (23 м²) с кладовой 15 м² - полностью автономные с уникальным характером'
        },
        {
          title: '8 000 м² земли',
          description: 'Обширная частная территория с полной приватностью и потенциалом развития'
        },
        {
          title: 'Беспрепятственный вид на море',
          description: 'Панорамный вид на Эгейское море и соседние острова Скиатос и Алониссос'
        },
        {
          title: 'Природное окружение',
          description: 'В мирной природе с аутентичной средиземноморской растительностью'
        }
      ]
    },
    specifications: {
      title: 'Характеристики недвижимости',
      details: [
        { label: 'Тип недвижимости', value: 'Два традиционных коттеджа' },
        { label: 'Коттедж 1', value: '32 м²' },
        { label: 'Коттедж 2', value: '23 м²' },
        { label: 'Кладовая', value: '15 м²' },
        { label: 'Площадь участка', value: '8 000 м²' },
        { label: 'Расположение', value: 'Остров Скопелос, Греция' },
        { label: 'Вид', value: 'Беспрепятственный вид на море и острова' },
        { label: 'Приватность', value: 'Полная приватность' },
        { label: 'Окружение', value: 'Тихая природная обстановка' },
        { label: 'Идеальное использование', value: 'Загородный дом / Инвестиция' },
        { label: 'Видимые острова', value: 'Скиатос и Алониссос' }
      ]
    },
    gallery: {
      title: 'Фотогалерея'
    },
    location: {
      title: 'Расположение',
      description: 'Расположенный на красивом острове Скопелос в архипелаге Спорады, этот объект предлагает легкий доступ к нетронутым пляжам, традиционным деревням и всем необходимым удобствам при сохранении полной приватности и спокойствия.'
    },
    contact: {
      title: 'Свяжитесь с нами',
      subtitle: 'Заинтересованы в этой уникальной недвижимости? Свяжитесь с нами сегодня.',
      form: {
        name: 'Полное имя',
        email: 'Электронная почта',
        phone: 'Номер телефона',
        message: 'Сообщение',
        submit: 'Отправить запрос'
      },
      success: 'Спасибо! Ваш запрос успешно отправлен.',
      error: 'Пожалуйста, заполните все обязательные поля.'
    },
    footer: {
      rights: 'Все права защищены.',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования'
    }
  }
};

export const galleryImages = [
  'https://images.unsplash.com/photo-1759668559041-5925eb01cd83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxHcmVlayUyMGNvdHRhZ2V8ZW58MHx8fHwxNzY4OTAyMjY4fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1657975096580-fbc02953d27a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxHcmVlayUyMGNvdHRhZ2V8ZW58MHx8fHwxNzY4OTAyMjY4fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1697572880765-9c640dbc9381?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxHcmVlayUyMGNvdHRhZ2V8ZW58MHx8fHwxNzY4OTAyMjY4fDA&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/18774948/pexels-photo-18774948.jpeg',
  'https://images.pexels.com/photos/34789500/pexels-photo-34789500.jpeg',
  'https://images.unsplash.com/photo-1623908112789-c33795afd551?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxNZWRpdGVycmFuZWFuJTIwdmlsbGF8ZW58MHx8fHwxNzY4OTAyMjc0fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1759848915476-11bb5f92f8cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxNZWRpdGVycmFuZWFuJTIwdmlsbGF8ZW58MHx8fHwxNzY4OTAyMjc0fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1763226950354-b04f6101acd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxNZWRpdGVycmFuZWFuJTIwdmlsbGF8ZW58MHx8fHwxNzY4OTAyMjc0fDA&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1641352576856-416aeb1baee7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxNZWRpdGVycmFuZWFuJTIwdmlsbGF8ZW58MHx8fHwxNzY4OTAyMjc0fDA&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/7902904/pexels-photo-7902904.jpeg',
  'https://images.pexels.com/photos/28460175/pexels-photo-28460175.jpeg'
];

// Gallery media items (images and videos)
// NOTE: Mock video URLs may be blocked by CORS. 
// To use videos: Upload your own videos to /app/frontend/public/videos/
// Then update the URLs below to: url: '/videos/your-video.mp4'
// See VIDEO_UPLOAD_GUIDE.md for detailed instructions
export const galleryMedia = [
  // Category 0: Exterior views
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/lsqhwj3t_DJI_0454.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/lsqhwj3t_DJI_0454.JPG',
    alt: {
      en: 'Aerial view of Skopelos cottages - drone shot showing both houses',
      gr: 'Αεροφωτογραφία των εξοχικών της Σκοπέλου - και τα δύο σπίτια',
      de: 'Luftaufnahme der Skopelos-Cottages - Drohnenaufnahme beider Häuser',
      he: 'מבט אווירי על הקוטג\'ים בסקופלוס - שני הבתים',
      fr: 'Vue aérienne des cottages de Skopelos - les deux maisons',
      zh: '斯科派洛斯小屋的航拍视图 - 两栋房屋',
      ar: 'منظر جوي لأكواخ سكوبيلوس - المنزلان',
      ru: 'Аэрофотосъёмка коттеджей Скопелоса - оба дома'
    }
  },
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/2l1gr2o8_DJI_0455.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/2l1gr2o8_DJI_0455.JPG',
    alt: {
      en: 'Drone view of traditional cottages with terracotta roofs',
      gr: 'Εναέρια άποψη παραδοσιακών εξοχικών με κεραμοσκεπές',
      de: 'Drohnenansicht traditioneller Cottages mit Terrakotta-Dächern',
      he: 'מבט רחפן על קוטג\'ים מסורתיים עם גגות טרקוטה',
      fr: 'Vue drone des cottages traditionnels aux toits en terre cuite',
      zh: '传统小屋的无人机视图 - 赤陶屋顶',
      ar: 'منظر بطائرة بدون طيار للأكواخ التقليدية بأسقف من الطين',
      ru: 'Вид с дрона на традиционные коттеджи с терракотовыми крышами'
    }
  },
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/srcet210_DJI_0457.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/srcet210_DJI_0457.JPG',
    alt: {
      en: 'Aerial perspective of property surrounded by olive groves',
      gr: 'Εναέρια άποψη ακινήτου περιτριγυρισμένου από ελαιώνες',
      de: 'Luftperspektive des Anwesens umgeben von Olivenhainen',
      he: 'מבט אווירי על הנכס מוקף בכרמי זיתים',
      fr: 'Perspective aérienne de la propriété entourée d\'oliveraies',
      zh: '被橄榄园环绕的房产航拍视角',
      ar: 'منظر جوي للعقار محاط ببساتين الزيتون',
      ru: 'Аэрофотосъёмка участка в окружении оливковых рощ'
    }
  },
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/edo4mn45_DJI_0461.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/edo4mn45_DJI_0461.JPG',
    alt: {
      en: 'Wide angle drone shot of Skopelos property',
      gr: 'Ευρυγώνια λήψη drone του ακινήτου',
      de: 'Weitwinkel-Drohnenaufnahme des Anwesens',
      he: 'צילום רחפן בזווית רחבה של הנכס',
      fr: 'Photo drone grand angle de la propriété',
      zh: '房产的广角无人机拍摄',
      ar: 'لقطة بزاوية واسعة للعقار',
      ru: 'Широкоугольная съёмка с дрона - участок'
    }
  },
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/zufj9rku_DJI_20240530094806_0068_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/zufj9rku_DJI_20240530094806_0068_D.JPG',
    alt: {
      en: 'Morning view from the porch',
      gr: 'Πρωινή θέα από τη βεράντα',
      de: 'Morgenblick von der Veranda',
      he: 'נוף בוקר מהמרפסת',
      fr: 'Vue matinale depuis le porche',
      zh: '从门廊看到的早晨景色',
      ar: 'منظر صباحي من الشرفة',
      ru: 'Утренний вид с веранды'
    }
  },
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/44z1k410_DJI_20240530173706_0097_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/44z1k410_DJI_20240530173706_0097_D.JPG',
    alt: {
      en: 'Morning view from the sunlit Mediterranean balcony',
      gr: 'Πρωινή θέα από το ηλιόλουστο μεσογειακό μπαλκόνι',
      de: 'Morgenblick vom sonnendurchfluteten mediterranen Balkon',
      he: 'נוף בוקר מהמרפסת הים-תיכונית מוארת השמש',
      fr: 'Vue matinale depuis le balcon méditerranéen ensoleillé',
      zh: '从阳光明媚的地中海阳台看到的早晨景色',
      ar: 'منظر صباحي من الشرفة المتوسطية المشمسة',
      ru: 'Утренний вид с залитого солнцем средиземноморского балкона'
    }
  },
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/70ujicq5_DJI_20240530181424_0102_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/70ujicq5_DJI_20240530181424_0102_D.JPG',
    alt: {
      en: 'Morning view from the sunlit Mediterranean balcony',
      gr: 'Πρωινή θέα από το ηλιόλουστο μεσογειακό μπαλκόνι',
      de: 'Morgenblick vom sonnendurchfluteten mediterranen Balkon',
      he: 'נוף בוקר מהמרפסת הים-תיכונית מוארת השמש',
      fr: 'Vue matinale depuis le balcon méditerranéen ensoleillé',
      zh: '从阳光明媚的地中海阳台看到的早晨景色',
      ar: 'منظر صباحي من الشرفة المتوسطية المشمسة',
      ru: 'Утренний вид с залитого солнцем средиземноморского балкона'
    }
  },
  {
    type: 'image',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/ml60iccf_DJI_20240530192605_0136_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/ml60iccf_DJI_20240530192605_0136_D.JPG',
    alt: {
      en: 'Corridor with a large, gnarled tree stump integrated into the structure',
      gr: 'Διάδρομος με μεγάλο ρόζο δέντρου ενσωματωμένο στη δομή',
      de: 'Korridor mit großem, knorrigem Baumstumpf in die Struktur integriert',
      he: 'מסדרון עם גזע עץ גדול ומפותל משולב במבנה',
      fr: 'Couloir avec un grand tronc d\'arbre noueux intégré à la structure',
      zh: '走廊中嵌入结构的大型扭曲树桩',
      ar: 'ممر مع جذع شجرة كبير متعرج مدمج في الهيكل',
      ru: 'Коридор с большим узловатым пнём, интегрированным в конструкцию'
    }
  },
  {
    type: 'video',
    category: 0,
    url: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/jyxg9w30_Create%20%C2%B7%20Nim%20skopelos%20timlapse.mp4',
    thumbnail: 'https://customer-assets.emergentagent.com/job_aegean-property/artifacts/lsqhwj3t_DJI_0454.JPG',
    alt: {
      en: 'Property timelapse video - sunrise to sunset',
      gr: 'Βίντεο timelapse ακινήτου - από ανατολή έως δύση',
      de: 'Zeitraffer-Video des Anwesens - Sonnenauf- bis Sonnenuntergang',
      he: 'סרטון טיימלאפס של הנכס - מזריחה עד שקיעה',
      fr: 'Vidéo timelapse de la propriété - du lever au coucher du soleil',
      zh: '房产延时视频 - 从日出到日落',
      ar: 'فيديو تايم لابس للعقار - من شروق الشمس إلى غروبها',
      ru: 'Таймлапс-видео участка - от рассвета до заката'
    }
  },
  // Category 1: Arrival & surroundings
  {
    type: 'image',
    category: 1,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/jnuov4ki_DJI_0458.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/jnuov4ki_DJI_0458.JPG',
    alt: {
      en: 'Aerial view of the property nestled in lush green hillside',
      gr: 'Αεροφωτογραφία του ακινήτου μέσα σε καταπράσινη πλαγιά',
      de: 'Luftaufnahme des Anwesens eingebettet in grünen Hügel',
      he: 'מבט אווירי על הנכס השוכן בגבעה ירוקה עבותה',
      fr: 'Vue aérienne de la propriété nichée dans une colline verdoyante',
      zh: '坐落在郁郁葱葱山坡上的房产航拍',
      ar: 'منظر جوي للعقار وسط التلال الخضراء',
      ru: 'Аэрофотосъёмка участка на зелёном склоне холма'
    }
  },
  {
    type: 'image',
    category: 1,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/5k57yxlr_DJI_0459.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/5k57yxlr_DJI_0459.JPG',
    alt: {
      en: 'Access road winding through olive groves to the property',
      gr: 'Δρόμος πρόσβασης που διασχίζει ελαιώνες προς το ακίνητο',
      de: 'Zufahrtsstraße durch Olivenhaine zum Anwesen',
      he: 'דרך הגישה המתפתלת בין כרמי זיתים אל הנכס',
      fr: 'Route d\'accès serpentant à travers les oliveraies vers la propriété',
      zh: '穿过橄榄园通往房产的蜿蜒道路',
      ar: 'طريق الوصول المتعرج عبر بساتين الزيتون إلى العقار',
      ru: 'Подъездная дорога через оливковые рощи к участку'
    }
  },
  {
    type: 'image',
    category: 1,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/82g6ebf4_DJI_0460.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/82g6ebf4_DJI_0460.JPG',
    alt: {
      en: 'Property approach with traditional white cottages visible through trees',
      gr: 'Προσέγγιση ακινήτου με παραδοσιακά λευκά εξοχικά μέσα από τα δέντρα',
      de: 'Annäherung an das Anwesen mit traditionellen weißen Cottages zwischen Bäumen',
      he: 'גישה לנכס עם קוטג\'ים לבנים מסורתיים נראים בין העצים',
      fr: 'Approche de la propriété avec les cottages blancs traditionnels visibles à travers les arbres',
      zh: '透过树木可见传统白色小屋的房产入口',
      ar: 'مقاربة العقار مع الأكواخ البيضاء التقليدية مرئية بين الأشجار',
      ru: 'Подъезд к участку с видом на традиционные белые коттеджи сквозь деревья'
    }
  },
  {
    type: 'image',
    category: 1,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/o8dqalku_DJI_20240529063642_0042_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/o8dqalku_DJI_20240529063642_0042_D.JPG',
    alt: {
      en: 'Stunning sunrise view with bougainvillea flowers and Aegean Sea panorama',
      gr: 'Εκπληκτική θέα ανατολής με βουκαμβίλιες και πανόραμα Αιγαίου',
      de: 'Atemberaubender Sonnenaufgang mit Bougainvillea-Blüten und Ägäis-Panorama',
      he: 'נוף זריחה מדהים עם פרחי בוגנוויליה ופנורמה של הים האגאי',
      fr: 'Vue lever de soleil époustouflante avec bougainvilliers et panorama sur la mer Égée',
      zh: '令人惊叹的日出景色，配有九重葛花和爱琴海全景',
      ar: 'منظر شروق مذهل مع زهور الجهنمية وبانوراما بحر إيجة',
      ru: 'Потрясающий вид на рассвет с бугенвиллеей и панорамой Эгейского моря'
    }
  },
  {
    type: 'image',
    category: 1,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/eqs1db27_DJI_20240530181527_0105_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/eqs1db27_DJI_20240530181527_0105_D.JPG',
    alt: {
      en: 'Charming hand-painted folk art flower mural along the entrance wall',
      gr: 'Γοητευτική τοιχογραφία με λαϊκά λουλούδια στον τοίχο της εισόδου',
      de: 'Bezaubernde handgemalte Volkskunst-Blumenwandbild entlang der Eingangsmauer',
      he: 'ציור קיר פרחוני עממי מקסים לאורך קיר הכניסה',
      fr: 'Charmante fresque florale peinte à la main le long du mur d\'entrée',
      zh: '入口墙上迷人的手绘民间艺术花卉壁画',
      ar: 'جدارية زهور شعبية ساحرة مرسومة يدوياً على طول جدار المدخل',
      ru: 'Очаровательная народная роспись с цветами вдоль входной стены'
    }
  },
  {
    type: 'image',
    category: 1,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/p43wm3fd_DJI_20240530181619_0107_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/p43wm3fd_DJI_20240530181619_0107_D.JPG',
    alt: {
      en: 'Vibrant bougainvillea flowers with traditional Greek mosaic artwork',
      gr: 'Ζωντανές βουκαμβίλιες με παραδοσιακό ελληνικό ψηφιδωτό',
      de: 'Leuchtende Bougainvillea-Blüten mit traditioneller griechischer Mosaikkunst',
      he: 'פרחי בוגנוויליה תוססים עם אמנות פסיפס יוונית מסורתית',
      fr: 'Bougainvilliers vibrants avec mosaïque grecque traditionnelle',
      zh: '鲜艳的九重葛花与传统希腊马赛克艺术',
      ar: 'زهور الجهنمية النابضة بالحياة مع فن الفسيفساء اليوناني التقليدي',
      ru: 'Яркая бугенвиллея с традиционной греческой мозаикой'
    }
  },
  {
    type: 'image',
    category: 1,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/581c5urr_DJI_20240530181643_0108_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/581c5urr_DJI_20240530181643_0108_D.JPG',
    alt: {
      en: 'Beautiful bird mosaic with blooming oleander flowers',
      gr: 'Όμορφο ψηφιδωτό πουλιού με ανθισμένες πικροδάφνες',
      de: 'Schönes Vogelmosaik mit blühenden Oleander-Blumen',
      he: 'פסיפס ציפור יפהפה עם פרחי הרדוף פורחים',
      fr: 'Belle mosaïque d\'oiseau avec lauriers-roses en fleurs',
      zh: '美丽的鸟类马赛克与盛开的夹竹桃花',
      ar: 'فسيفساء طائر جميلة مع زهور الدفلى المتفتحة',
      ru: 'Красивая мозаика с птицей и цветущим олеандром'
    }
  },
  // Category 2: Sea & island views
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/94kxj4ni_DJI_0418.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/94kxj4ni_DJI_0418.JPG',
    alt: {
      en: 'Panoramic Aegean Sea view with distant islands and hillside villages',
      gr: 'Πανοραμική θέα του Αιγαίου με μακρινά νησιά και χωριά στην πλαγιά',
      de: 'Panoramablick auf die Ägäis mit entfernten Inseln und Hangdörfern',
      he: 'נוף פנורמי לים האגאי עם איים רחוקים וכפרי מדרון',
      fr: 'Vue panoramique sur la mer Égée avec îles lointaines et villages à flanc de colline',
      zh: '爱琴海全景，可见远处岛屿和山坡村庄',
      ar: 'منظر بانورامي لبحر إيجة مع جزر بعيدة وقرى على التلال',
      ru: 'Панорамный вид на Эгейское море с далёкими островами и деревнями на склоне'
    }
  },
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/1usub5ej_DJI_0421.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/1usub5ej_DJI_0421.JPG',
    alt: {
      en: 'Aerial view of Glossa village with dramatic mountain peaks and sea panorama',
      gr: 'Αεροφωτογραφία της Γλώσσας με εντυπωσιακές βουνοκορφές και πανόραμα θάλασσας',
      de: 'Luftaufnahme von Glossa Dorf mit dramatischen Berggipfeln und Meerespanorama',
      he: 'מבט אווירי על כפר גלוסה עם פסגות הרים דרמטיות ופנורמת ים',
      fr: 'Vue aérienne du village de Glossa avec pics montagneux et panorama marin',
      zh: '格洛萨村的航拍，可见壮观的山峰和海景全景',
      ar: 'منظر جوي لقرية غلوسا مع قمم جبال دراماتيكية وبانوراما البحر',
      ru: 'Аэрофотосъёмка деревни Глосса с живописными горными вершинами и морской панорамой'
    }
  },
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/rktie207_DJI_0425.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/rktie207_DJI_0425.JPG',
    alt: {
      en: 'Breathtaking view towards Skiathos and Alonissos islands through cypress trees',
      gr: 'Εκπληκτική θέα προς Σκιάθο και Αλόννησο μέσα από κυπαρίσσια',
      de: 'Atemberaubender Blick auf Skiathos und Alonissos durch Zypressen',
      he: 'נוף עוצר נשימה לאיי סקיאתוס ואלוניסוס דרך ברושים',
      fr: 'Vue à couper le souffle vers Skiathos et Alonissos à travers les cyprès',
      zh: '透过柏树眺望斯基亚索斯岛和阿洛尼索斯岛的壮丽景色',
      ar: 'منظر خلاب نحو سكياثوس وألونيسوس عبر أشجار السرو',
      ru: 'Захватывающий вид на Скиатос и Алониссос сквозь кипарисы'
    }
  },
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/zc18rzl0_DJI_20240529063607_0041_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/zc18rzl0_DJI_20240529063607_0041_D.JPG',
    alt: {
      en: 'Golden sunset view from the garden with pomegranate flowers',
      gr: 'Χρυσό ηλιοβασίλεμα από τον κήπο με άνθη ροδιάς',
      de: 'Goldener Sonnenuntergang vom Garten mit Granatapfelblüten',
      he: 'נוף שקיעה זהובה מהגינה עם פרחי רימון',
      fr: 'Coucher de soleil doré depuis le jardin avec fleurs de grenadier',
      zh: '从花园眺望的金色日落，配有石榴花',
      ar: 'منظر غروب ذهبي من الحديقة مع زهور الرمان',
      ru: 'Золотистый закат из сада с цветами граната'
    }
  },
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/zs7a6f2y_DJI_20240529074419_0044_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/zs7a6f2y_DJI_20240529074419_0044_D.JPG',
    alt: {
      en: 'Dramatic morning mist with islands silhouetted on the horizon',
      gr: 'Δραματική πρωινή ομίχλη με νησιά στον ορίζοντα',
      de: 'Dramatischer Morgennebel mit Inseln am Horizont',
      he: 'ערפל בוקר דרמטי עם צלליות איים באופק',
      fr: 'Brume matinale dramatique avec îles silhouettées à l\'horizon',
      zh: '戏剧性的晨雾，地平线上岛屿剪影',
      ar: 'ضباب صباحي دراماتيكي مع صور ظلية للجزر في الأفق',
      ru: 'Драматичный утренний туман с силуэтами островов на горизонте'
    }
  },
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/5sfma16f_DJI_20240529123348_0047_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/5sfma16f_DJI_20240529123348_0047_D.JPG',
    alt: {
      en: 'Glossa village church with terracotta rooftops overlooking Aegean Sea',
      gr: 'Εκκλησία Γλώσσας με κεραμοσκεπές και θέα στο Αιγαίο',
      de: 'Glossa Dorfkirche mit Terrakotta-Dächern und Ägäis-Blick',
      he: 'כנסיית כפר גלוסה עם גגות טרקוטה משקיפה על הים האגאי',
      fr: 'Église du village de Glossa avec toits en terre cuite surplombant la mer Égée',
      zh: '格洛萨村教堂，赤陶屋顶俯瞰爱琴海',
      ar: 'كنيسة قرية غلوسا بأسقف من الطين تطل على بحر إيجة',
      ru: 'Церковь деревни Глосса с терракотовыми крышами и видом на Эгейское море'
    }
  },
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/9ogjyaqk_DJI_20240529123403_0048_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/9ogjyaqk_DJI_20240529123403_0048_D.JPG',
    alt: {
      en: 'Traditional Greek village rooftops cascading down to the turquoise sea',
      gr: 'Παραδοσιακές ελληνικές στέγες που κατεβαίνουν προς τη γαλαζοπράσινη θάλασσα',
      de: 'Traditionelle griechische Dorfhausdächer zum türkisfarbenen Meer',
      he: 'גגות כפר יווני מסורתי משתפלים לים הטורקיז',
      fr: 'Toits de village grec traditionnel descendant vers la mer turquoise',
      zh: '传统希腊村庄屋顶层叠而下至碧蓝大海',
      ar: 'أسطح القرية اليونانية التقليدية تتدرج نحو البحر الفيروزي',
      ru: 'Традиционные греческие крыши, спускающиеся к бирюзовому морю'
    }
  },
  {
    type: 'image',
    category: 2,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/mki6abqp_dji_fly_20240529_065404_449_1716954893598_pano_optimized.jpg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/mki6abqp_dji_fly_20240529_065404_449_1716954893598_pano_optimized.jpg',
    alt: {
      en: '360° panorama of Skopelos coastline with Skiathos and Alonissos islands',
      gr: 'Πανόραμα 360° της ακτογραμμής της Σκοπέλου με Σκιάθο και Αλόννησο',
      de: '360°-Panorama der Skopelos-Küste mit Skiathos und Alonissos',
      he: 'פנורמה של 360° של קו החוף של סקופלוס עם איי סקיאתוס ואלוניסוס',
      fr: 'Panorama 360° du littoral de Skopelos avec Skiathos et Alonissos',
      zh: '斯科派洛斯海岸线360°全景，可见斯基亚索斯岛和阿洛尼索斯岛',
      ar: 'بانوراما 360 درجة لساحل سكوبيلوس مع جزر سكياثوس وألونيسوس',
      ru: '360° панорама побережья Скопелоса с островами Скиатос и Алониссос'
    }
  },
  // Category 3: Cottage interiors
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/8hjmw0u8_DJI_20240530184349_0109_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/8hjmw0u8_DJI_20240530184349_0109_D.JPG',
    alt: {
      en: 'Cottage 1 - Cozy bedroom with terracotta tiles and garden doorway',
      gr: 'Εξοχικό 1 - Άνετη κρεβατοκάμαρα με πλακάκια τερακότα και πόρτα προς τον κήπο',
      de: 'Cottage 1 - Gemütliches Schlafzimmer mit Terrakotta-Fliesen und Gartentür',
      he: 'קוטג\' 1 - חדר שינה נעים עם אריחי טרקוטה ודלת לגינה',
      fr: 'Cottage 1 - Chambre confortable avec carrelage en terre cuite et porte vers le jardin',
      zh: '小屋1 - 舒适卧室，赤陶地砖和花园门廊',
      ar: 'الكوخ 1 - غرفة نوم مريحة بالبلاط الطيني وباب الحديقة',
      ru: 'Коттедж 1 - Уютная спальня с терракотовой плиткой и дверью в сад'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/rk7m0ze0_DJI_20240530184423_0113_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/rk7m0ze0_DJI_20240530184423_0113_D.JPG',
    alt: {
      en: 'Cottage 1 - Traditional bedroom with wooden beam ceiling and decorative ceramic plates',
      gr: 'Εξοχικό 1 - Παραδοσιακή κρεβατοκάμαρα με ξύλινα δοκάρια και διακοσμητικά πιάτα',
      de: 'Cottage 1 - Traditionelles Schlafzimmer mit Holzbalkendecke und dekorativen Keramiktellern',
      he: 'קוטג\' 1 - חדר שינה מסורתי עם תקרת קורות עץ וצלחות קרמיקה דקורטיביות',
      fr: 'Cottage 1 - Chambre traditionnelle avec poutres en bois et assiettes décoratives en céramique',
      zh: '小屋1 - 传统卧室，木梁天花板和装饰陶瓷盘',
      ar: 'الكوخ 1 - غرفة نوم تقليدية بسقف عوارض خشبية وأطباق سيراميك زخرفية',
      ru: 'Коттедж 1 - Традиционная спальня с деревянными балками и декоративными керамическими тарелками'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/1y6ey78j_DJI_20240530184513_0116_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/1y6ey78j_DJI_20240530184513_0116_D.JPG',
    alt: {
      en: 'Cottage 1 - Rustic wrought iron chandelier with traditional Greek decor',
      gr: 'Εξοχικό 1 - Ρουστίκ πολυέλαιος από σφυρήλατο σίδερο με παραδοσιακή ελληνική διακόσμηση',
      de: 'Cottage 1 - Rustikaler Schmiedeeisen-Kronleuchter mit traditionellem griechischen Dekor',
      he: 'קוטג\' 1 - נברשת ברזל מחושל כפרית עם עיצוב יווני מסורתי',
      fr: 'Cottage 1 - Lustre rustique en fer forgé avec décor grec traditionnel',
      zh: '小屋1 - 乡村风格锻铁吊灯，传统希腊装饰',
      ar: 'الكوخ 1 - ثريا حديد مطاوع ريفية مع ديكور يوناني تقليدي',
      ru: 'Коттедж 1 - Кованая люстра в деревенском стиле с традиционным греческим декором'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/u8c076qa_DJI_20240530184657_0122_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/u8c076qa_DJI_20240530184657_0122_D.JPG',
    alt: {
      en: 'Cottage 1 - Living area with traditional patterned cushions and daybed seating',
      gr: 'Εξοχικό 1 - Σαλόνι με παραδοσιακά μοτίβα μαξιλαριών και καναπέ-κρεβάτι',
      de: 'Cottage 1 - Wohnbereich mit traditionell gemusterten Kissen und Tagesbett',
      he: 'קוטג\' 1 - אזור מגורים עם כריות בדוגמאות מסורתיות וספת יום',
      fr: 'Cottage 1 - Espace de vie avec coussins à motifs traditionnels et banquette',
      zh: '小屋1 - 起居区，传统图案靠垫和日间沙发床',
      ar: 'الكوخ 1 - منطقة المعيشة بوسائد منقوشة تقليدية وأريكة نهارية',
      ru: 'Коттедж 1 - Гостиная зона с традиционными узорчатыми подушками и кушеткой'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/t2p9c2fn_DJI_20240530184644_0121_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/t2p9c2fn_DJI_20240530184644_0121_D.JPG',
    alt: {
      en: 'Cottage 1 - Cozy daybed with colorful traditional Greek textiles',
      gr: 'Εξοχικό 1 - Άνετος καναπές-κρεβάτι με πολύχρωμα παραδοσιακά ελληνικά υφάσματα',
      de: 'Cottage 1 - Gemütliches Tagesbett mit bunten traditionellen griechischen Textilien',
      he: 'קוטג\' 1 - ספת יום נעימה עם טקסטיל יווני מסורתי צבעוני',
      fr: 'Cottage 1 - Banquette confortable avec textiles grecs traditionnels colorés',
      zh: '小屋1 - 舒适日间床配传统希腊彩色织物',
      ar: 'الكوخ 1 - أريكة نهارية مريحة بأقمشة يونانية تقليدية ملونة',
      ru: 'Коттедж 1 - Уютная кушетка с красочным традиционным греческим текстилем'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/sn3ireuc_DJI_20240530184714_0123_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/sn3ireuc_DJI_20240530184714_0123_D.JPG',
    alt: {
      en: 'Cottage 1 - Bathroom with hand-painted vanity cabinet and decorative tiles',
      gr: 'Εξοχικό 1 - Μπάνιο με χειροποίητο ντουλάπι νιπτήρα και διακοσμητικά πλακάκια',
      de: 'Cottage 1 - Badezimmer mit handbemaltem Waschtisch und dekorativen Fliesen',
      he: 'קוטג\' 1 - חדר אמבטיה עם ארון כיור מצויר ביד ואריחים דקורטיביים',
      fr: 'Cottage 1 - Salle de bain avec meuble vasque peint à la main et carreaux décoratifs',
      zh: '小屋1 - 浴室配手绘梳妆柜和装饰瓷砖',
      ar: 'الكوخ 1 - حمام بخزانة مغسلة مرسومة يدوياً وبلاط زخرفي',
      ru: 'Коттедж 1 - Ванная комната с расписным туалетным столиком и декоративной плиткой'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/44jujphs_DJI_20240530184738_0126_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/44jujphs_DJI_20240530184738_0126_D.JPG',
    alt: {
      en: 'Cottage 1 - Compact kitchen with traditional cabinets and oven',
      gr: 'Εξοχικό 1 - Μικρή κουζίνα με παραδοσιακά ντουλάπια και φούρνο',
      de: 'Cottage 1 - Kompakte Küche mit traditionellen Schränken und Ofen',
      he: 'קוטג\' 1 - מטבח קומפקטי עם ארונות מסורתיים ותנור',
      fr: 'Cottage 1 - Cuisine compacte avec placards traditionnels et four',
      zh: '小屋1 - 紧凑厨房配传统橱柜和烤箱',
      ar: 'الكوخ 1 - مطبخ صغير بخزائن تقليدية وفرن',
      ru: 'Коттедж 1 - Компактная кухня с традиционными шкафами и духовкой'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/8r9xxtoc_DJI_20240530171755_0074_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/8r9xxtoc_DJI_20240530171755_0074_D.JPG',
    alt: {
      en: 'Cottage 2 - Spacious bedroom with charming loft mezzanine and wooden ladder',
      gr: 'Εξοχικό 2 - Ευρύχωρη κρεβατοκάμαρα με γοητευτικό πατάρι και ξύλινη σκάλα',
      de: 'Cottage 2 - Geräumiges Schlafzimmer mit charmantem Loft-Zwischengeschoss und Holzleiter',
      he: 'קוטג\' 2 - חדר שינה מרווח עם גלריה מקסימה וסולם עץ',
      fr: 'Cottage 2 - Chambre spacieuse avec charmante mezzanine et échelle en bois',
      zh: '小屋2 - 宽敞卧室配迷人阁楼夹层和木梯',
      ar: 'الكوخ 2 - غرفة نوم واسعة مع طابق علوي ساحر وسلم خشبي',
      ru: 'Коттедж 2 - Просторная спальня с очаровательной мезонин-галереей и деревянной лестницей'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/zoc8o3yj_DJI_20240530171841_0077_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/zoc8o3yj_DJI_20240530171841_0077_D.JPG',
    alt: {
      en: 'Cottage 2 - Bedroom with lace curtains, loft sleeping area and traditional decor',
      gr: 'Εξοχικό 2 - Κρεβατοκάμαρα με δαντελένιες κουρτίνες, πατάρι και παραδοσιακή διακόσμηση',
      de: 'Cottage 2 - Schlafzimmer mit Spitzenvorhängen, Loft-Schlafbereich und traditionellem Dekor',
      he: 'קוטג\' 2 - חדר שינה עם וילונות תחרה, אזור שינה בגלריה ועיצוב מסורתי',
      fr: 'Cottage 2 - Chambre avec rideaux en dentelle, espace couchage en mezzanine et décor traditionnel',
      zh: '小屋2 - 卧室配蕾丝窗帘、阁楼睡眠区和传统装饰',
      ar: 'الكوخ 2 - غرفة نوم بستائر دانتيل ومنطقة نوم علوية وديكور تقليدي',
      ru: 'Коттедж 2 - Спальня с кружевными шторами, спальным местом на антресоли и традиционным декором'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/nmpfr5az_DJI_20240530171946_0082_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/nmpfr5az_DJI_20240530171946_0082_D.JPG',
    alt: {
      en: 'Cottage 2 - Living space with TV area, wardrobe and loft ladder access',
      gr: 'Εξοχικό 2 - Χώρος διαβίωσης με τηλεόραση, ντουλάπα και πρόσβαση στο πατάρι',
      de: 'Cottage 2 - Wohnbereich mit TV-Ecke, Kleiderschrank und Loft-Leiter-Zugang',
      he: 'קוטג\' 2 - אזור מגורים עם פינת טלוויזיה, ארון בגדים וגישה לגלריה',
      fr: 'Cottage 2 - Espace de vie avec coin TV, armoire et accès à la mezzanine',
      zh: '小屋2 - 生活空间配电视区、衣柜和阁楼梯子',
      ar: 'الكوخ 2 - منطقة معيشة بركن التلفاز وخزانة ملابس وسلم الطابق العلوي',
      ru: 'Коттедж 2 - Жилое пространство с ТВ-зоной, шкафом и лестницей на антресоль'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/hecat7z9_DJI_20240530172018_0085_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/hecat7z9_DJI_20240530172018_0085_D.JPG',
    alt: {
      en: 'Cottage 2 - Cozy interior with mezzanine loft and rustic wooden features',
      gr: 'Εξοχικό 2 - Άνετο εσωτερικό με πατάρι και ρουστίκ ξύλινα στοιχεία',
      de: 'Cottage 2 - Gemütliches Interieur mit Mezzanin-Loft und rustikalen Holzelementen',
      he: 'קוטג\' 2 - פנים נעים עם גלריה ואלמנטים כפריים מעץ',
      fr: 'Cottage 2 - Intérieur confortable avec mezzanine et éléments rustiques en bois',
      zh: '小屋2 - 温馨内部配夹层阁楼和乡村木质元素',
      ar: 'الكوخ 2 - داخلي مريح مع طابق علوي وعناصر خشبية ريفية',
      ru: 'Коттедж 2 - Уютный интерьер с мезонином и деревенскими деревянными элементами'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/pm0m6y98_DJI_20240530172111_0089_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/pm0m6y98_DJI_20240530172111_0089_D.JPG',
    alt: {
      en: 'Cottage 2 - Window view with bougainvillea framing sea and mountain panorama',
      gr: 'Εξοχικό 2 - Θέα από το παράθυρο με βουκαμβίλια και πανόραμα θάλασσας και βουνού',
      de: 'Cottage 2 - Fensterblick mit Bougainvillea, Meer- und Bergpanorama',
      he: 'קוטג\' 2 - נוף מהחלון עם בוגנוויליה ממסגרת ים והרים',
      fr: 'Cottage 2 - Vue de la fenêtre avec bougainvilliers encadrant mer et montagne',
      zh: '小屋2 - 窗景配九重葛，远眺海山全景',
      ar: 'الكوخ 2 - منظر من النافذة مع الجهنمية تؤطر بانوراما البحر والجبل',
      ru: 'Коттедж 2 - Вид из окна с бугенвиллеей, обрамляющей панораму моря и гор'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/fsvo9gu4_DJI_20240530172549_0093_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/fsvo9gu4_DJI_20240530172549_0093_D.JPG',
    alt: {
      en: 'Cottage 2 - Modern bathroom with white vanity and glass shower',
      gr: 'Εξοχικό 2 - Μοντέρνο μπάνιο με λευκό έπιπλο νιπτήρα και ντουζιέρα',
      de: 'Cottage 2 - Modernes Badezimmer mit weißem Waschtisch und Glasdusche',
      he: 'קוטג\' 2 - חדר אמבטיה מודרני עם ארון כיור לבן ומקלחון זכוכית',
      fr: 'Cottage 2 - Salle de bain moderne avec meuble vasque blanc et douche vitrée',
      zh: '小屋2 - 现代浴室配白色洗漱台和玻璃淋浴房',
      ar: 'الكوخ 2 - حمام حديث بخزانة مغسلة بيضاء ودش زجاجي',
      ru: 'Коттедж 2 - Современная ванная комната с белой тумбой и стеклянной душевой'
    }
  },
  {
    type: 'image',
    category: 3,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/j5x4ay78_DJI_20240530172641_0095_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/j5x4ay78_DJI_20240530172641_0095_D.JPG',
    alt: {
      en: 'Cottage 2 - Bedroom with single bed, loft area and window with mountain views',
      gr: 'Εξοχικό 2 - Κρεβατοκάμαρα με μονό κρεβάτι, πατάρι και παράθυρο με θέα βουνό',
      de: 'Cottage 2 - Schlafzimmer mit Einzelbett, Loftbereich und Fenster mit Bergblick',
      he: 'קוטג\' 2 - חדר שינה עם מיטה יחידה, גלריה וחלון עם נוף להרים',
      fr: 'Cottage 2 - Chambre avec lit simple, mezzanine et fenêtre vue montagne',
      zh: '小屋2 - 卧室配单人床、阁楼区和山景窗',
      ar: 'الكوخ 2 - غرفة نوم بسرير مفرد وطابق علوي ونافذة بإطلالة جبلية',
      ru: 'Коттедж 2 - Спальня с односпальной кроватью, антресолью и окном с видом на горы'
    }
  },
  // Category 4: Outdoor living areas
  {
    type: 'image',
    category: 4,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/xpxouw9j_DJI_20240530094806_0068_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/xpxouw9j_DJI_20240530094806_0068_D.JPG',
    alt: {
      en: 'Shaded pergola with outdoor dining table and panoramic sea views',
      gr: 'Σκιασμένη πέργκολα με τραπεζαρία και πανοραμική θέα στη θάλασσα',
      de: 'Schattige Pergola mit Esstisch im Freien und Panorama-Meerblick',
      he: 'פרגולה מוצלת עם שולחן אוכל חיצוני ונוף ים פנורמי',
      fr: 'Pergola ombragée avec table à manger extérieure et vue panoramique sur la mer',
      zh: '遮阳凉棚配户外餐桌和全景海景',
      ar: 'برجولا مظللة بطاولة طعام خارجية وإطلالات بانورامية على البحر',
      ru: 'Затенённая пергола с обеденным столом на открытом воздухе и панорамным видом на море'
    }
  },
  {
    type: 'image',
    category: 4,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/chkwik7g_DJI_20240530173706_0097_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/chkwik7g_DJI_20240530173706_0097_D.JPG',
    alt: {
      en: 'Terrace lounge with cushioned seating and sweeping island views',
      gr: 'Βεράντα με αναπαυτικά καθίσματα και εκπληκτική θέα στα νησιά',
      de: 'Terrassenlounge mit gepolsterten Sitzen und weitem Inselblick',
      he: 'מרפסת עם ישיבה מרופדת ונוף מרהיב לאיים',
      fr: 'Terrasse salon avec sièges rembourrés et vue panoramique sur les îles',
      zh: '露台休息区配软垫座椅和开阔岛景',
      ar: 'شرفة صالة بمقاعد مبطنة وإطلالات واسعة على الجزر',
      ru: 'Терраса-лаунж с мягкими сиденьями и захватывающим видом на острова'
    }
  },
  {
    type: 'image',
    category: 4,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/egquscr5_DJI_20240530180400_0098_D.JPG',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/egquscr5_DJI_20240530180400_0098_D.JPG',
    alt: {
      en: 'Evening terrace atmosphere with warm lighting and Mediterranean ambiance',
      gr: 'Βραδινή ατμόσφαιρα βεράντας με ζεστό φωτισμό και μεσογειακή αίσθηση',
      de: 'Abendliche Terrassenatmosphäre mit warmem Licht und mediterranem Ambiente',
      he: 'אווירת מרפסת ערב עם תאורה חמה ואווירה ים-תיכונית',
      fr: 'Atmosphère de terrasse en soirée avec éclairage chaleureux et ambiance méditerranéenne',
      zh: '傍晚露台氛围，温暖灯光和地中海风情',
      ar: 'أجواء الشرفة المسائية بإضاءة دافئة وأجواء متوسطية',
      ru: 'Вечерняя атмосфера террасы с тёплым освещением и средиземноморским колоритом'
    }
  },
  {
    type: 'image',
    category: 4,
    url: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/ode38cq0_dji_mimo_20240530_192610_0_1717092569794_photo.jpg',
    thumbnail: 'https://customer-assets.emergentagent.com/job_8e4dc794-01c5-4aa3-adec-b02ef8fc9fa7/artifacts/ode38cq0_dji_mimo_20240530_192610_0_1717092569794_photo.jpg',
    alt: {
      en: 'Unique architectural feature - ancient olive tree trunk integrated into cottage structure',
      gr: 'Μοναδικό αρχιτεκτονικό στοιχείο - αρχαίος κορμός ελιάς ενσωματωμένος στη δομή',
      de: 'Einzigartiges architektonisches Merkmal - alter Olivenbaumstamm in die Cottage-Struktur integriert',
      he: 'תכונה אדריכלית ייחודית - גזע עץ זית עתיק משולב במבנה הקוטג\'',
      fr: 'Caractéristique architecturale unique - tronc d\'olivier ancien intégré à la structure',
      zh: '独特建筑特色 - 古老橄榄树干融入小屋结构',
      ar: 'ميزة معمارية فريدة - جذع شجرة زيتون قديم مدمج في هيكل الكوخ',
      ru: 'Уникальная архитектурная особенность - древний ствол оливы, интегрированный в структуру коттеджа'
    }
  }
];